export default function PHP_array_slice() {
  return (
    <div>
      <h1>PHP_array_slice</h1>
    </div>
  );
}
